import Typography from '@mui/material/Typography';
import { AdjustmentType } from '../../models/adjustment.types';

export const EmptyAdjustments: React.FC<{ type: AdjustmentType }> = (props) => {
  return (
    <div
      style={{
        height: '85%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          width: '385px',
        }}
      >
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.7188 35.0812H45.6L36.8688 23.325L29.7875 32.6063L25.1125 26.625L18.7188 35.0812ZM12.875 47.25C11.775 47.25 10.8125 46.8375 9.9875 46.0125C9.1625 45.1875 8.75 44.225 8.75 43.125V4.625C8.75 3.525 9.1625 2.5625 9.9875 1.7375C10.8125 0.9125 11.775 0.5 12.875 0.5H51.375C52.475 0.5 53.4375 0.9125 54.2625 1.7375C55.0875 2.5625 55.5 3.525 55.5 4.625V43.125C55.5 44.225 55.0875 45.1875 54.2625 46.0125C53.4375 46.8375 52.475 47.25 51.375 47.25H12.875ZM12.875 43.125H51.375V4.625H12.875V43.125ZM12.875 4.625V43.125V4.625ZM4.625 55.5C3.525 55.5 2.5625 55.0875 1.7375 54.2625C0.9125 53.4375 0.5 52.475 0.5 51.375V8.75H4.625V51.375H47.25V55.5H4.625Z"
            fill="#BCBEDC"
          />
        </svg>
        <Typography fontSize={18} color={'#3C419A'}>
          {`W tej chwili nie zostały zaimportowane żadne ${
            props.type === AdjustmentType.means ? 'sposoby' : 'uprawnienia do'
          } dostosowań.`}
        </Typography>
      </div>
    </div>
  );
};
